import React, { useRef } from 'react';
import { MorevertIcons } from '../../../../icons/icons';

interface ContextMenuButtonProps {
  readonly row: unknown;
  readonly onOpenMenu: (
    e: React.MouseEvent<HTMLButtonElement>,
    row: unknown
  ) => void;
  readonly onCloseMenu: () => void;
  readonly anchorEl: HTMLElement | null;
}

export function ContextMenuButton({ row, onOpenMenu }: ContextMenuButtonProps) {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <button
        ref={buttonRef}
        onClick={(e) => {
          e.stopPropagation(); // Prevents row click if using row selection
          onOpenMenu(e, row);
        }}
        className='p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-900 rounded-lg transition-all duration-200 focus:outline-none active:scale-95'
    >
      <MorevertIcons className='w-5 h-5' />
    </button>
  );
}
